/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import cx from "classnames";
import { ROUTES } from "@nf/constants";
import { LinkWithLocale } from "components/LinkWithLocale";
import React from "react";
import styles from "./SettingsMenuItem.module.scss";

export interface ISettingsMenuItemProps {
  submenuKey: string;
  isActive: boolean;
  children: React.ReactNode;
}

export const SettingsMenuItem = ({
  submenuKey,
  isActive,
  children,
}: ISettingsMenuItemProps) => (
  <li
    className={cx(styles.menuItem, {
      [styles.menuItemActive]: isActive,
    })}
  >
    <LinkWithLocale href={`${ROUTES.SETTINGS_SCREEN}/${submenuKey}`}>
      <a className={styles.link}>{children}</a>
    </LinkWithLocale>
  </li>
);
